module.exports = __webpack_public_path__ + "static/media/15@1280w.1df3e1e6.jpg";